import * as v from "valibot";

// response
export const KubernetesSchema = v.object({
  KubernetesVersion: v.string(),
});
export type Kubernetes = v.InferOutput<typeof KubernetesSchema>;

export const ClusterSetSchema = v.object({
  ClusterId: v.string(),
  ClusterManageMode: v.string(),
  ClusterName: v.string(),
  Kubernetes: KubernetesSchema,
});
export type ClusterSet = v.InferOutput<typeof ClusterSetSchema>;

export const DataSchema = v.object({
  ClusterSet: v.array(ClusterSetSchema),
});
export type Data = v.InferOutput<typeof DataSchema>;

export const ResponseSchema = v.object({
  Data: DataSchema,
  RequestId: v.string(),
});
export type Response = v.InferOutput<typeof ResponseSchema>;
